module.exports = __webpack_public_path__ + "img/brand-sketch.77160303.svg";